// isMobileDevice — เช็คว่าเป็น "มือถือจริง" ไม่ใช่แค่หน้าจอแคบ (ต่างจาก `useResponsive().mobileOnly` ที่วัด
// จาก viewport width — desktop ที่ resize หน้าต่างให้แคบก็ถูกนับเป็น mobile ด้วยเหมือนกัน ซึ่งพอสำหรับ
// สลับ layout แต่ไม่พอสำหรับตัดสินใจซ่อนปุ่มควบคุมแผนที่ที่ผูกกับพฤติกรรม "มีนิ้วบีบซูมจริงไหม" ไม่ใช่
// "หน้าจอเท่าไหร่")
// เกณฑ์: user agent ของมือถือ (Android/iPhone/iPod/Windows Phone) หรือ iPad (รวม iPadOS 13+ ที่ Safari
// รายงาน UA เป็น "Macintosh" ธรรมดา ต้องเช็ค `maxTouchPoints` แยกให้จับได้)
// ไม่ผูก React state เพราะ user agent ของอุปกรณ์ไม่เปลี่ยนระหว่างการใช้งานหน้าเดียว ไม่ต้อง re-render ตาม
//
// isMobileDevice — checks the *actual device*, not just a narrow viewport (unlike
// `useResponsive().mobileOnly`, which measures viewport width — a desktop browser resized narrow
// counts as mobile too, fine for switching layout but not for deciding whether to hide the map
// controls, which is about "does this have a real pinch-to-zoom finger", not "how wide is the screen")
// Criteria: a mobile user agent (Android/iPhone/iPod/Windows Phone) or iPad (including iPadOS 13+,
// whose Safari reports a plain "Macintosh" UA — `maxTouchPoints` catches it separately)
// Not wired to React state — the device's user agent doesn't change during a single page visit, so
// there's nothing to re-render on
export const isMobileDevice = () => {
  if (typeof navigator === "undefined") return false
  const ua = navigator.userAgent || ""
  if (/Android|iPhone|iPod|Windows Phone|Mobile/i.test(ua)) return true
  if (/iPad/i.test(ua)) return true
  return navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1
}
